import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useBreadcrumb } from "@/contexts/BreadcrumbContext";
import { OrderForm, type OrderPayment } from "@/components/OrderForm";

export function CreateOrder() {
  const navigate = useNavigate();
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { label: "Sales", path: "/products" },
      { label: "Orders", path: "/sales/orders" },
      { label: "Create", path: "/sales/orders/new" },
    ]);

    return () => {
      clearBreadcrumbs();
    };
  }, [setBreadcrumbs, clearBreadcrumbs]);

  return (
    <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
      <OrderForm
        mode="create"
        payment={null}
        onSaved={(payment?: OrderPayment) => {
          if (payment?._id) {
            navigate(`/sales/orders/${payment._id}`, { replace: true });
          }
        }}
      />
    </div>
  );
}
